import { Grid } from '@mantine/core'

import { LLMReasoningBadge } from '../LLMReasoningBadge/LLMReasoningBadge'
import { DocumentValidityBadge } from '../DocumentValidityBadge/DocumentValidityBadge'

import { LLMReasoningRowProps } from './LLMReasoningRow.types'
import styles from './LLMReasoningRow.module.scss'
import { Typography } from '@percent/lemonade'

export function LLMReasoningRow({ label, value, status, documentValidity }: Readonly<LLMReasoningRowProps>) {
  return (
    <Grid gutter={16}>
      <Grid.Col span={1} miw={150}>
        <Typography className={styles.label} variant="default-bold">
          {label}
        </Typography>
      </Grid.Col>
      <Grid.Col span="auto">{value}</Grid.Col>
      {status && (
        <Grid.Col span={3} miw={180} className={styles.badgeWrapper}>
          <LLMReasoningBadge status={status} />
        </Grid.Col>
      )}
      {documentValidity && (
        <Grid.Col span={3} miw={180} className={styles.badgeWrapper}>
          <DocumentValidityBadge documentValidity={documentValidity} />
        </Grid.Col>
      )}
    </Grid>
  )
}
